import script from "./ExclamationIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclamationIcon.vue?vue&type=script&setup=true&lang=js"

import "./ExclamationIcon.vue?vue&type=style&index=0&id=112b85e5&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112b85e5"]])

export default __exports__